import { render, staticRenderFns } from "./tracksnew.vue?vue&type=template&id=8ae905cc&lang=html&"
import script from "./tracksnew.vue?vue&type=script&lang=js&"
export * from "./tracksnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports